import { mountPublicPath } from "@/mountPath";

/**
 * `<link rel="manifest">` を現在のmountへ向け直す。
 *
 * 現行のindex.htmlはmanifest linkを静的に持たず、head内のinline bootstrapが
 * mount別に生成する。この関数が働くのは、`/b/manifest.json` を焼いた**古い
 * cached HTML**が使われた場合だけで、そのmount違いを事後に是正する。
 * (bootstrap成功後の applyBoardRuntimeConfig も同じ値を書くため冪等)
 */
export function applyManifestLink(
  documentLike: Pick<Document, "querySelector"> = globalThis.document,
  pathname: string = globalThis.location.pathname,
): boolean {
  const link = documentLike.querySelector<HTMLLinkElement>(
    'link[rel="manifest"]',
  );
  if (link === null) return false;
  link.setAttribute("href", mountPublicPath(pathname, "/manifest.json"));
  return true;
}
